import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/menu',
    name: RouteName.Menu,
    component: () => import('@/pages/Menu/MenuList'),
    meta: {
      breadcrumb: {
        label: 'Меню',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/menu/create',
    name: 'menuItemCreate',
    component: () => import('@/pages/Menu/MenuCreate'),
    meta: {
      breadcrumb: {
        label: 'Новое блюдо',
        parent: RouteName.Menu,
      },
    },
  },
  {
    path: '/menu/:id',
    name: 'menuItemEdit',
    component: () => import('@/pages/Menu/MenuSingle'),
    props: { isEdit: false },
    meta: {
      breadcrumb: {
        label: 'Редактирование блюда',
        parent: RouteName.Menu,
      },
    },
  },
]
